import { Component, Inject, Input } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NbDialogRef, NB_DIALOG_CONFIG } from '@nebular/theme';

@Component({
  selector: 'app-sortable-list',
  templateUrl: './sortable-list.component.html',
  styleUrls: ['./sortable-list.component.scss']
})
export class SortableListComponent {
  @Input() items: any[] = [];
  @Input() displayField: string = '';
  @Input() positionField: string = '';
  @Input() title: string = 'Sort Items';
  @Input() message: string = '';

  constructor(
    protected dialogRef: NbDialogRef<SortableListComponent>,
    @Inject(NB_DIALOG_CONFIG) private config: any
  ) {
    if (config?.context) {
      const ctx = config.context;
      this.items = Array.isArray(ctx.items) ? [...ctx.items] : this.items;
      this.displayField = ctx.displayField ?? this.displayField;
      this.positionField = ctx.positionField ?? this.positionField;
      this.title = ctx.title ?? this.title;
      this.message = ctx.message ?? this.message;
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
  }

  save() {
    if (this.positionField) {
      this.items.forEach((item, index) => {
        item[this.positionField] = index + 1; // or 0-based index if needed
      });
    }
  
    this.dialogRef.close(this.items);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}